/* eslint-disable indent */
/* eslint-disable no-trailing-spaces */
/* eslint-disable comma-dangle */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/button-has-type */
/* eslint-disable no-multi-spaces */
/* eslint-disable prefer-destructuring */
/* eslint-disable consistent-return */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import {
    Viewer,
    Cartographic,
    Cartesian2,
    Cartesian3,
    CesiumTerrainProvider,
    Cesium3DTileset,
    createWorldTerrainAsync,
    HeadingPitchRange,
    Math as CesiumMath,
    Matrix3,
    Matrix4,
    HeadingPitchRoll,
    Model,
    Ion,
    IonImageryProvider,
    IonResource,
    JulianDate,
    SceneMode,
    Color,
    DirectionalLight,
    ScreenSpaceEventHandler,
    sampleTerrainMostDetailed,
    Transforms
} from 'cesium';
import * as Cesium from 'cesium';
import 'cesium/Build/Cesium/Widgets/widgets.css';
import { cesiumToken } from '../../app/three_d_constants';
import {
    addLabelAboveBuilding,
    addModel,
    addModelClamped,
    addSmoothTerrainLine,
    isSameView,
    loadTreeAtGround
} from '../../app/utilities';

window.Cesium = Cesium;

const CesiumViewer = ({
      onCameraChange,
      externalCameraView,
      setExternalCameraView,
      location, 
      now, 
      id 
    }) => {
    Ion.defaultAccessToken = cesiumToken;
    const cesiumContainerRef = useRef(null);
    const viewerRef = useRef(null);
    const lastAppliedViewRef = useRef(null); // Stores last applied camera view
    const lastSentRef = useRef(null);
    const skipSyncRef = useRef(false);

    const [bloomSettings, setBloomSettings] = useState({
        contrast: 0,
        brightness: 0,
        delta: 2,
        sigma: 3.78,
        stepSize: 5
    });
    const [lightingFadeOutDistance, setLightingFadeOutDistance] = useState(6500000.0);
    const [lightIntensity, setLightIntensity] = useState(1.0);
    const [darkness, setDarkness] = useState(0.85);
    const [enableLighting, setEnableLighting] = useState(true);
    const [enableShadows, setEnableShadows] = useState(true);
    const [isTilesLoading, setIsTilesLoading] = useState(false);

    useEffect(() => {
        window.CESIUM_BASE_URL = '/cesium/';
        let viewer;

        const initCesium = async () => {
              // Get the terrain provider asynchronously
            //   const terrainProvider = await createWorldTerrainAsync();
            let terrainAssetId;
            let imageryProvider;
            if (!now) {
                terrainAssetId = location.terrainAssetId;
                imageryProvider = await IonImageryProvider.fromAssetId(location.imageryAssetId);
            } else {
                terrainAssetId = 1;
            }
            const terrainResource = await IonResource.fromAssetId(terrainAssetId);
            const terrainProvider = await CesiumTerrainProvider.fromUrl(terrainResource);
            
            viewer = new Viewer(cesiumContainerRef.current, {
                terrainProvider,
                shouldAnimate: true,
                scene3DOnly: true,
                sceneMode: SceneMode.SCENE3D,
                timeline: false,
                animation: false,
                sceneModePicker: false,
                baseLayerPicker: false,
                fullscreenButton: false,
                navigationHelpButton: false,
                geocoder: false,
                infoBox: false,
                selectionIndicator: false,
                vrButton: false,
                homeButton: true
            });
            viewerRef.current = viewer;

            // Click handler to log terrain coordinates and height
            const handler = new ScreenSpaceEventHandler(viewer.scene.canvas);

            handler.setInputAction(async (movement) => {
                // Get a ray from the camera through the click position
                const ray = viewer.scene.camera.getPickRay(movement.position);

                // Pick the point on the terrain (not just the ellipsoid)
                const cartesian = viewer.scene.globe.pick(ray, viewer.scene);

                if (cartesian) {
                    const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
                    const lon = CesiumMath.toDegrees(cartographic.longitude);
                    const lat = CesiumMath.toDegrees(cartographic.latitude);

                    try {
                        const terrainSample = await sampleTerrainMostDetailed(viewer.terrainProvider, [cartographic]);
                        const height = terrainSample[0].height;

                        console.log('Clicked terrain point:');
                        console.log(`  Latitude:  ${lat.toFixed(8)}`);
                        console.log(`  Longitude: ${lon.toFixed(8)}`);
                        console.log(`  Height:    ${height.toFixed(2)} meters`);
                    } catch (err) {
                        console.warn('Failed to sample terrain:', err);
                    }
                } else {
                    console.warn('Click did not hit visible terrain.');
                }
            }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);

            if (!now) {
                // Remove default Bing imagery
                viewer.imageryLayers.removeAll();
                const blurryImagery = await IonImageryProvider.fromAssetId(3954);
                viewer.imageryLayers.addImageryProvider(blurryImagery);

                viewer.imageryLayers.addImageryProvider(imageryProvider);
            }
            
            //   viewer.scene.verticalExaggeration = 0.5;
            //  viewer.scene.verticalExaggerationRelativeHeight = -500;
            viewer.scene.requestRender();
            viewer.scene.camera.setView({
                destination: Cartesian3.fromDegrees(
                    location.initCamera.lat,  // Longitude
                    location.initCamera.lon,   // Latitude
                    location.initCamera.height
                ),
                orientation: {
                    heading: CesiumMath.toRadians(location.initCamera.heading), // 300 degrees
                    pitch: CesiumMath.toRadians(location.initCamera.pitch),   // Look slightly downward
                    roll: location.initCamera.roll,
                },
            });
            
            // Max performance
            viewer.resolutionScale = Math.min(window.devicePixelRatio, 1.5);
            
            // Set datetime
            const date = JulianDate.fromIso8601(location.dateTime);
            viewer.clock.currentTime = date;

            // Set graphical fidelity
            viewer.scene.fxaa = true;
            viewer.scene.postProcessStages.fxaa.enabled = true;

            // // Camera angle limitations
            // viewer.scene.postRender.addEventListener(() => {
            //     const camera = viewer.scene.camera;
            //     const carto = Cartographic.fromCartesian(camera.positionWC);
            //     const lon = CesiumMath.toDegrees(carto.longitude);
            //     const lat = CesiumMath.toDegrees(carto.latitude);
            //     const height = carto.height;

            //     const maxPitch = CesiumMath.toRadians(-60); // no more than 30° above nadir

            //     if (camera.pitch > maxPitch) {
            //         camera.setView({
            //             destination: Cartesian3.fromDegrees(lon, lat, height),
            //             orientation: {
            //                 heading: camera.heading,
            //                 pitch: maxPitch,
            //                 roll: camera.roll
            //             }
            //         });
            //     }
            // });

            if (!now) {
                viewer.scene.shadowMap.enabled = true;
                viewer.scene.shadowMap.darkness = 1.0; // Default is 0.5
                viewer.scene.shadowMap.size = 512;
                viewer.scene.shadowMap.softShadows = true;

                // Apply initial settings
                viewer.scene.shadowMap.darkness = darkness;
                viewer.shadows = enableShadows;
                viewer.scene.globe.enableLighting = enableLighting;

                const bloom = viewer.scene.postProcessStages.bloom;
                bloom.enabled = true;
                bloom.uniforms.contrast = bloomSettings.contrast;
                bloom.uniforms.brightness = bloomSettings.brightness;
                bloom.uniforms.delta = bloomSettings.delta;
                bloom.uniforms.sigma = bloomSettings.sigma;
                bloom.uniforms.stepSize = bloomSettings.stepSize;
            }

            viewer.scene.skyAtmosphere.show = true;
            viewer.scene.fog.enabled = true;

            viewer.scene.globe.maximumAnisotropy = 16;
            viewer.scene.globe.depthTestAgainstTerrain = true;

            const MAX_PITCH_DEG = 45;
            const MAX_PITCH_RAD = CesiumMath.toRadians(-MAX_PITCH_DEG); // Cesium: pitch tilts up = more negative
            viewer.scene.camera.percentageChanged = 0.1;
            viewer.scene.preRender.addEventListener(() => {
                const camera = viewer.scene.camera;
                const pitch = camera.pitch;
            
                if (pitch > MAX_PITCH_RAD) {
                    const pos = camera.positionWC;
                    const dir = camera.directionWC;
                    const up = camera.upWC;
            
                    // Use current camera position, force pitch back to limit
                    const heading = camera.heading;
                    const roll = camera.roll;
            
                    // Clamp using setView
                    camera.setView({
                        destination: pos,
                        orientation: {
                            heading,
                            pitch: MAX_PITCH_RAD,
                            roll
                        }
                    });
                }
            });         

            if (id === 'right') {
                // Disable all camera interactions
                viewer.scene.screenSpaceCameraController.enableRotate = false;
                viewer.scene.screenSpaceCameraController.enableTranslate = false;
                viewer.scene.screenSpaceCameraController.enableZoom = false;
                viewer.scene.screenSpaceCameraController.enableTilt = false;
                viewer.scene.screenSpaceCameraController.enableLook = false;
              
                // Optional: prevent keyboard inputs too
                viewer.scene.screenSpaceCameraController.enableInputs = false;
            }

            if (!now) {
                // 1. Fences
                (location.fences || []).forEach((fence) => {
                    addSmoothTerrainLine(viewer, viewer.terrainProvider, fence.points);
                });
                // TRACKER: Keep track of how many tilesets are actively loading
    let loadingCount = location.misc.length; 
    if (loadingCount > 0) setIsTilesLoading(true);

// 2. 3D Tilesets
await Promise.all(location.misc.map(async ({ assetId, name, brightness = 1.0 }) => {
    try {
        const resource = await IonResource.fromAssetId(assetId);
        const tileset = await Cesium3DTileset.fromUrl(resource);
// Decrement the count when this specific tileset finishes loading
tileset.allTilesLoaded.addEventListener(() => {
    loadingCount -= 1;
    if (loadingCount <= 0) {
        setIsTilesLoading(false);
    }
});
        tileset.customShader = new Cesium.CustomShader({
            lightingModel: Cesium.LightingModel.PBR,
            uniforms: {
                u_brightness: {
                    type: Cesium.UniformType.FLOAT,
                    value: brightness
                }
            },
            fragmentShaderText: `
            void fragmentMain(FragmentInput fsInput, inout czm_modelMaterial material) {
                // 1. Force matte, non-shiny surface
                material.roughness = 1.0; 
                material.specular = vec3(0.0);
                
                // 2. Apply our custom brightness multiplier 
                material.diffuse *= u_brightness;
                
                // 3. FAKE AMBIENT LIGHT: Prevent the shadow side from ever being pitch black
                // by forcing the material to emit 15% of its own color at all times.
                material.emissive = material.diffuse * 0.15;
            }
        `
        });

        // Restore just a tiny bit of ambient environment light (instead of 0.0)
        tileset.imageBasedLighting.imageBasedLightingFactor = new Cartesian2(0.1, 0.1);

        viewer.scene.primitives.add(tileset);
        if (name) {
            await tileset.readyPromise;

            const boundingCenter = tileset.boundingSphere.center;
            const cartographic = Cartographic.fromCartesian(boundingCenter);
            const lat = CesiumMath.toDegrees(cartographic.latitude);
            const lon = CesiumMath.toDegrees(cartographic.longitude);
            const height = cartographic.height;

            addLabelAboveBuilding(viewer, lat, lon, height, name);
        }
    } catch (err) {
        loadingCount -= 1; // Decrement even on error so it doesn't get stuck
        if (loadingCount <= 0) setIsTilesLoading(false);
        console.error(`Failed to load (ID: ${assetId})`, err);
    }
}));
                console.log(viewer.scene);

                // 3. Batched Vegetation, Props, AND Buildings
                const allPositions = [
                    // Map buildings (Note: buildings use 'path' instead of 'url')
                    ...(location.buildings || []).map((b) => ({
                        ...b,
                        url: b.path,
                        isBuilding: true
                    })),
                    ...(location.woods_tree_positions || []).map((p) => ({ ...p, url: '/models/tree3.glb' })),
                    ...(location.bush_positions || []).map((p) => ({ ...p, url: '/models/bush.glb' })),
                    ...(location.telegraph_positions || []).map((p) => ({ ...p, url: '/models/telegraph_pole.glb' })),
                    { 
                        lat: 38.89036672, 
                        lon: -77.42159492, 
                        scale: 1, 
                        heading: -180, 
                        url: '/models/medieval_carriage_coach_scan.glb' 
                    }
                ];

                const cartographics = allPositions.map((pos) => Cartographic.fromDegrees(pos.lon, pos.lat));

                try {
                    await sampleTerrainMostDetailed(viewer.terrainProvider, cartographics);
                    
                    await Promise.all(allPositions.map(async (pos, index) => {
                        // Use building's specific height if defined, otherwise use sampled terrain height
                        const exactHeight = pos.height !== undefined ? pos.height : (cartographics[index].height || 0);
                        
                        const position = Cartesian3.fromDegrees(pos.lon, pos.lat, exactHeight);
                        const hpr = new HeadingPitchRoll(CesiumMath.toRadians(pos.heading || 0), 0, 0);
                        const modelMatrix = Transforms.headingPitchRollToFixedFrame(position, hpr);
                
                        try {
                            const model = await Model.fromGltfAsync({
                                url: pos.url,
                                modelMatrix,
                                scale: pos.scale || 1.0
                            });
                            viewer.scene.primitives.add(model);

                            // If this item is a building and needs a label, add it now
                            if (pos.isBuilding && pos.showLabel) {
                                addLabelAboveBuilding(viewer, pos.lat, pos.lon, exactHeight, pos.name);
                            }
                        } catch (err) {
                            console.error(`Failed to load model ${pos.url}`, err);
                        }
                    }));

                    // Force Cesium to render a frame now that all models are placed
                    viewer.scene.requestRender();
                } catch (err) {
                    console.error('Failed to batch-sample terrain for models:', err);
                }
            } else {
                try {
                    const resource = await IonResource.fromAssetId(2275207);
                    const tileset = await Cesium3DTileset.fromUrl(resource);
                    viewer.scene.primitives.add(tileset);
                } catch (err) {
                    console.error(`Failed to load (ID: ${2275207})`, err);
                }
            }

            // Listen for camera changes
            if (id === 'left') {
                const THROTTLE_MS = 30; // Sync ~33 times per second
                let lastSyncTime = 0;

                viewer.scene.preRender.addEventListener(() => {
                    if (skipSyncRef.current) return;

                    // Renamed 'now' to 'currentTime' to fix the no-shadow error
                    const currentTime = Date.now();
                    if (currentTime - lastSyncTime < THROTTLE_MS) return;

                    const camera = viewer.camera;
                    const pos = camera.positionCartographic;
                    
                    const view = {
                        lat: CesiumMath.toDegrees(pos.latitude),
                        lon: CesiumMath.toDegrees(pos.longitude),
                        height: pos.height,
                        heading: CesiumMath.toDegrees(camera.heading),
                        pitch: CesiumMath.toDegrees(camera.pitch),
                        roll: CesiumMath.toDegrees(camera.roll),
                        source: id,
                    };

                    if (!isSameView(view, lastSentRef.current)) {
                        lastSyncTime = currentTime;
                        lastSentRef.current = view;
                        onCameraChange?.(view);
                    }
                });
            }
        };

        initCesium();

        return () => {
          if (viewer && !viewer.isDestroyed()) {
            viewer.destroy();
          }
          };
    }, [onCameraChange, id]);

    // Respond to external camera view changes
    if (id === 'right') {
        useEffect(() => {
            const currentViewer = viewerRef.current;
            if (!currentViewer || !externalCameraView || externalCameraView.source === id) return;
            
            // ⬇️ Subtract 30 feet only if not the source
    
            const heightOffset = id === 'right' ? -30 : 0;
            const adjustedView = {
              ...externalCameraView,
              height: externalCameraView.height + heightOffset
            };
    
            // Avoid repeating already-applied views
            if (isSameView(adjustedView, lastAppliedViewRef.current)) return;
    
            skipSyncRef.current = true;
            currentViewer.scene.camera.setView({
              destination: Cartesian3.fromDegrees(
                adjustedView.lon,
                adjustedView.lat,
                adjustedView.height
              ),
              orientation: {
                heading: CesiumMath.toRadians(adjustedView.heading),
                pitch: CesiumMath.toRadians(adjustedView.pitch),
                roll: CesiumMath.toRadians(adjustedView.roll),
              },
          });
    
          currentViewer.scene.requestRender();
    
          // Delay unsetting skip flag to avoid re-triggering moveEnd
          setTimeout(() => {
            skipSyncRef.current = false;
          }, 5);
        }, [externalCameraView, id]);
    }

    useEffect(() => {
        const viewer = viewerRef.current;
        if (!viewer) return;
    
        const bloom = viewer.scene.postProcessStages.bloom;
        if (bloom) {
            bloom.uniforms.contrast = bloomSettings.contrast;
            bloom.uniforms.brightness = bloomSettings.brightness;
            bloom.uniforms.delta = bloomSettings.delta;
            bloom.uniforms.sigma = bloomSettings.sigma;
            bloom.uniforms.stepSize = bloomSettings.stepSize;
            console.log('Updated bloom settings:', bloomSettings);
            viewer.scene.requestRender();
        }
    }, [bloomSettings]);
    
    useEffect(() => {
        const viewer = viewerRef.current;
        if (!viewer) return;
    
        viewer.scene.shadowMap.darkness = darkness;
        console.log('Updated darkness settings:', darkness);
        viewer.scene.requestRender();
    }, [darkness]);
    
    useEffect(() => {
        const viewer = viewerRef.current;
        if (!viewer) return;
    
        viewer.scene.globe.enableLighting = enableLighting;
        console.log('Updated enableLighting settings:', enableLighting);
        viewer.scene.requestRender();
    }, [enableLighting]);
    
    useEffect(() => {
        const viewer = viewerRef.current;
        console.log(viewer);
        if (!viewer) return;
    
        viewer.shadows = enableShadows;
        console.log('Updated enableShadows settings:', enableShadows);
        viewer.scene.requestRender();
    }, [enableShadows]);
    
    useEffect(() => {
        const viewer = viewerRef.current;
        console.log(viewer);
        if (!viewer) return;
    
        viewer.scene.globe.lightingFadeOutDistance = lightingFadeOutDistance;
        viewer.scene.requestRender();
    }, [lightingFadeOutDistance]);

    useEffect(() => {
        const viewer = viewerRef.current;
        if (!viewer) return;
        console.log(viewer);
        // viewer.scene.globe.lightingFadeOutDistance = lightingFadeOutDistance;
        // viewer.scene.globe.atmosphereLightIntensity  = lightIntensity;
        viewer.scene.requestRender();
    }, [lightIntensity]);

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            {isTilesLoading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1000,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontSize: '1.5rem',
                    pointerEvents: 'none'
                }}
                >
                    Loading Scene Assets...
                </div>
            )}
            <div
                ref={cesiumContainerRef}
                style={{ width: '100%', height: '100%', display: 'block' }}
            />
        </div>
    );
};

export default CesiumViewer;
